import { FunctionComponent, ReactNode, MouseEventHandler } from 'react';
import classNames from 'classnames';

import styles from '../main.scss';
import { StyledButton } from '../../Common/Button/StyledButton';

type BoxProps = {
    isSelected?: boolean;
    isDisabled?: boolean;
    dataTn: string;
    label: ReactNode;
    value: string;
    onClick: MouseEventHandler<HTMLElement>;
    size?: keyof typeof styles;
};

export const Box: FunctionComponent<BoxProps> = ({
    isSelected = false,
    isDisabled = false,
    dataTn,
    label,
    value,
    onClick,
    size = 'medium',
}) => {
    const boxClasses = classNames(
        {
            [styles.selected]: isSelected && !isDisabled,
            [styles.disabled]: isDisabled && !isSelected,
            [styles.disabledSelected]: isSelected && isDisabled,
        },
        styles[size],
        styles.box
    );

    return (
        <StyledButton
            className={boxClasses}
            dataTn={dataTn}
            onClick={onClick}
            disabled={isDisabled}
            value={value}
        >
            {label}
        </StyledButton>
    );
};
